














import { Component } from 'vue-property-decorator';
import Create from '@/layouts/Create';

import CreateBlock from '@/views/CRUD/Create.vue';
import TitleReturn from '@/components/TitleReturn.vue';
import FormView from './_form.vue';

import DifficultiesModule from "@/store/difficulties";
import DifficultiesEntityModule from "@/store/difficulties/entity";
import ResponseHandlerModule from "@/store/modules/responseHandler";

@Component({
    components: {
        CreateBlock,
        TitleReturn,
        FormView,
    },
})
export default class DifficultiesCreatePage extends Create {
    fieldErrors: Record<string, string> = {};

    returnBefore() {
        this.$router.push({ name: 'difficulties' });
    }

    async create(data: any) {
        this.fieldErrors = {};
        try {
            await DifficultiesEntityModule.create(data);
            ResponseHandlerModule.showNotify({ message: 'Проблема создана', type: 'ok' });
            this.returnBefore();
        } catch (response) {
            const error = response.response.data;

            // unknown fields error
            if (error.message) {
                ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });
                return;
            }

            this.fieldErrors = error.errors.fields || {};

            if (this.fieldErrors.defaultIcon) {
                ResponseHandlerModule.showNotify({ message: this.fieldErrors.defaultIcon, type: 'fail' });
            }

            if (this.fieldErrors.activeIcon) {
                ResponseHandlerModule.showNotify({ message: this.fieldErrors.activeIcon, type: 'fail' });
            }
        }
    }

    init() {
        this.title = DifficultiesModule.pageSettings.titleAdd;
    }

    async mounted() {
        await this.init();
    }
}
